<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="bb" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="d-flex flex-row justify-content-end">
          <McButton
            icon="icon-outline_arrow-left"
            class="m-2"
            variant="secondary"
            @click="
              $router.push({
                name: 'Service Order List',
              })
            "
            :text="$t('global.back')"
          />

          <McButton
            v-if="isMGMAndMO"
            class="m-2"
            variant="secondary"
            icon="icon-outline_history"
            :text="$t('maintenance.integrationHistory')"
            @click="$bvModal.show('integration-log-modal-value-help')"
          />
          
          <IntegrationLogHistoryModal
            v-if="isMGMAndMO"
            module="maintenance"
            :identifier="$route.params.id"
          />

          <McButton
            v-if="
              serviceOrder.status === 'Finished' ||
              serviceOrder.status === 'InProgress' ||
              serviceOrder.status === 'Confirmed'
            "
            icon="icon-outline_printer"
            class="m-2"
            :variant="serviceOrder.status === 'Finished' ? 'primary' : 'secondary'"
            iconPosition="right"
            :text="
              serviceOrder.status === 'Finished'
                ? $t('maintenance.printServiceCost')
                : $t('maintenance.printSpk')
            "
            @click="printPage"
          />

          <b-dropdown
            id="dropdown-left"
            variant="primary"
            class="m-2"
            v-if="
              serviceOrder.status != 'Verification' && serviceOrder.status != 'Finished' && render
            "
          >
            <template v-slot:button-content>
              {{ $t('global.action.changeStatus') }}
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item-button
              v-if="serviceOrder.status == 'Draft'"
              @click="changeStatus('Confirmed')"
              >{{ $t('maintenance.status.confirmed') }}</b-dropdown-item-button
            >
            <b-dropdown-item-button
              v-if="isMGMAndMO && serviceOrder.status == 'Draft'"
              @click="changeStatus('InProgress-bypass')"
            >
              {{ $t('maintenance.status.inProgress') }}
            </b-dropdown-item-button>
            <b-dropdown-item-button
              v-if="serviceOrder.status == 'Confirmed'"
              @click="changeStatus('InProgress')"
              >{{ $t('maintenance.order.filter.inProgress') }}</b-dropdown-item-button
            >
            <b-dropdown-item-button
              v-if="serviceOrder.status == 'InProgress'"
              @click="changeStatus('Verification')"
              >{{ $t('maintenance.order.filter.verification') }}</b-dropdown-item-button
            >
            <b-dropdown-item-button
              v-if="isMGMAndMO && serviceOrder.status == 'InProgress' && render"
              @click="handleFinish(true)"
            >
              {{ $t($t('maintenance.serviceToNormal')) }}
            </b-dropdown-item-button>
          </b-dropdown>
          <McButton
            variant="primary"
            class="m-2"
            v-else-if="serviceOrder.status == 'Verification' && render"
            @click="handleFinish(false)"
            icon="icon-fill_checkmark"
            :text="$t('maintenance.serviceToNormal')"
          />
        </div>
      </div>
    </div>
    <b-skeleton-wrapper :loading="!render">
      <template #loading>
        <b-skeleton width="45%" height="100px" class="my-5"></b-skeleton>

        <b-card class="mt-4">
          <b-row>
            <b-col md="3" class="mb-3" v-for="index in 6" :key="index">
              <b-skeleton width="100%" height="90px"></b-skeleton>
            </b-col>
          </b-row>
          <b-skeleton width="100%" height="90px"></b-skeleton>
        </b-card>

        <b-card class="mt-4">
          <b-skeleton width="100%" height="100px"></b-skeleton>
        </b-card>

        <b-card>
          <b-skeleton width="100%" height="100px"></b-skeleton>
        </b-card>

        <b-card>
          <b-row>
            <b-col md="6">
              <b-skeleton width="100%" height="100px"></b-skeleton>
            </b-col>
            <b-col md="6">
              <b-skeleton width="100%" height="100px"></b-skeleton>
            </b-col>
          </b-row>
        </b-card>
      </template>

      <McWizard class="mc-wizard" :items="computedItems" :activeKey="localActiveKey" />

      <InfoFleet
        v-if="!loadingInfo"
        :status="serviceOrder.status"
        ref="infoFleet"
        :totalKilometer="kilometerData"
        :totalHourmeter="hourmeterData"
        :totalRefrigerator="refrigeratorData"
        @save-success="refetchServiceOrder"
      />
      <ListCompService
        :status="serviceOrder.status"
        @update-total-price="refresh = true"
        @updateTotalData="updateTotalData"
      />
      <ListService :status="serviceOrder.status" @update-total-price="refresh = true" />
      <AddInfo
        :status="serviceOrder.status"
        :init-memo="serviceOrder.memo"
        :service-order-id="serviceOrder.serviceOrderId"
      />
      <TotalService
        :serviceOrder="serviceOrder"
        :status="serviceOrder.status"
        :refreshPage="refresh"
        @pageRefreshed="refresh = false"
      />
    </b-skeleton-wrapper>

    <StatusFinish
      v-if="!loadingInfo && modal"
      :serviceOrder="serviceOrder"
      :kilometerData="kilometerData"
      :hourmeterData="hourmeterData"
      :refrigeratorData="refrigeratorData"
      :showRefrigerator="isMGMAndMO && serviceOrder.vehicle?.refrigerator !== null"
      @changeStatus="changeStatus"
      @closeModal="modal = false"
    />
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McWizard from '@/components/McWizard'
import McButton from '@/components/McButton'
import ListCompService from './ListCompService'
import InfoFleet from './InfoFleet'
import ListService from './ListService'
import AddInfo from './AddInfo'
import TotalService from './TotalService'
import filteredItems from '../ModalFilter/filteredItems'
import { GET_SERVICE_ORDER, UPDATE_SERVICE_ORDER, UPDATE_SERVICE_ORDER_STATUS } from '@/services/api/maintenance/serviceorder'
import StatusFinish from './Modal/StatusFinish.vue'
import { DOWNLOAD_SERVICE_WORK_ORDER } from '@/services/api/maintenance/ServiceWorkOrder'
import IntegrationLogHistoryModal from '@/router/views/master/fleet/components/IntegrationLogHistoryModal'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McWizard,
    ListCompService,
    ListService,
    AddInfo,
    InfoFleet,
    McButton,
    TotalService,
    StatusFinish,
    IntegrationLogHistoryModal,
  },
  mixins: [Helper],
  apollo: {
    serviceOrder: {
      query: GET_SERVICE_ORDER,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            serviceOrderId: +this.$route.params.id,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return

        this.serviceOrder = data.serviceOrder.serviceOrder
        switch (this.serviceOrder.status) {
          case 'Draft':
            this.localActiveKey = 'step_1'
            break
          case 'Confirmed':
            this.localActiveKey = 'step_2'
            break
          case 'InProgress':
            this.localActiveKey = 'step_3'
            break
          case 'Verification':
            this.localActiveKey = 'step_4'
            break
          case 'Finished':
            this.localActiveKey = 'step_5'
            break
          case 'Completed':
            this.localActiveKey = 'step_6'
            break
        }

        this.render = true
      },
    },
  },

  props: {
    activeKey: {
      type: String,
      default: 'step_1',
    },
    withNumber: {
      type: Boolean,
      default: true,
    },
    withSubLabel: {
      type: Boolean,
      default: false,
    },
    withSubSubLabel: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      finishBypass: false,
      serviceOrder: {},
      render: false,
      refresh: false,
      localActiveKey: this.activeKey,
      modal: false,
      loadingInfo: false,
      kilometerData: 0,
      hourmeterData: 0,
      refrigeratorData: 0,
    }
  },

  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isMGMAndMO() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data.features?.maintenance_order
      )
    },
    title() {
      return `Detail ${this.$t('maintenance.frontPage.title.serviceOrder')} ${
        this.serviceOrder.code ?? ''
      }`
    },

    bb() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceOrder'),
          to: { name: 'Service Order List' },
        },
        {
          text: `Detail ${this.$t('maintenance.frontPage.title.serviceOrder')} ${
            this.serviceOrder.code ?? ''
          }`,
        },
      ]
    },

    computedItems() {
      const items = [...this.getProgressBar()]
      if (this.withSubLabel) {
        items.forEach((item, idx) => {
          items[idx] = {
            ...item,
            sub_label: 'Sub-step 1',
          }
        })
      }

      if (this.withSubSubLabel) {
        items.forEach((item, idx) => {
          items[idx] = {
            ...item,
            subsub__label: 'Sub-step 2',
          }
        })
      }

      return items
    },
  },

  watch: {
    kilometerData: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.loadingInfo = true

          setTimeout(() => {
            this.loadingInfo = false
          }, 500)
        }
      },
    },
    hourmeterData: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.loadingInfo = true

          setTimeout(() => {
            this.loadingInfo = false
          }, 500)
        }
      },
    },
    refrigeratorData: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.loadingInfo = true

          setTimeout(() => {
            this.loadingInfo = false
          }, 500)
        }
      },
    },
  },

  methods: {
    refetchServiceOrder() {
      this.$apollo.queries.serviceOrder.refetch()
    },
    getProgressBar() {
      return [
        {
          key: 'step_1',
          label: this.$t('maintenance.status.draft'),
        },
        {
          key: 'step_2',
          label: this.$t('maintenance.status.confirmed'),
        },
        {
          key: 'step_3',
          label: this.$t('maintenance.status.inProgress'),
        },
        {
          key: 'step_4',
          label: this.$t('maintenance.status.verify'),
        },
        {
          key: 'step_5',
          label: this.$t('maintenance.status.finished'),
        },
      ]
    },
    handleBack() {
      this.$router.push({
        name: 'Sales Order',
      })
    },
    handleCancel() {
      this.$router.push({
        name: 'Sales Order',
      })
    },
    changeStatus(status, actualEndTime, odometer, hourmeter, refrigerator) {
      const nextStatus = status.replace('-bypass', '')

      if (nextStatus === 'InProgress' && this.$refs.infoFleet) {
        const etaValidation = this.$refs.infoFleet.validateEtaServicePeriodeForInProgress()

        if (!etaValidation.valid) {
          const errorMessage =
            etaValidation.reason === 'unsaved'
              ? this.$t('maintenance.order.text.saveEtaTimeBeforeInProgress')
              : this.$t('maintenance.order.text.etaTimeRequiredBeforeInProgress')

          this.$mcToast.error(errorMessage)
          return
        }
      }

      const oldData = Object.keys(this.serviceOrder).reduce((acc, key) => {
        if (
          [
            'address',
            'discount',
            'geofenceId',
            'locationType',
            'memo',
            'otherFee',
            'picId',
            'status',
            'tax',
            'vehicleId',
            'actualEndTime',
            'vehicle.odometer',
            'vehicle.hourmeter',
            'vehicle.refrigerator',
          ].includes(key)
        ) {
          acc[key] = this.serviceOrder[key]
        }
        return acc
      }, {})

      const hasNoServiceSchedule =
        !this.kilometerData && !this.hourmeterData && !this.refrigeratorData
      const kilometerData = this.kilometerData || hasNoServiceSchedule
        ? { odometer: odometer ?? this.serviceOrder.vehicle.odometer }
        : { odometer: this.serviceOrder.vehicle.odometer }
      const hourmeterData = this.hourmeterData || hasNoServiceSchedule
        ? { hourmeter: hourmeter ?? this.serviceOrder.vehicle.hourmeter }
        : { hourmeter: this.serviceOrder.vehicle.hourmeter }
      const refrigeratorData = this.refrigeratorData
        ? { refrigerator: refrigerator ?? this.serviceOrder.vehicle.refrigerator }
        : { refrigerator: null }

      let isBypass
      if(status.includes("-bypass") || this.finishBypass){
        isBypass = true
        status = nextStatus
      }

      // FE validation estimate end date
      if (
        this.isMGMAndMO &&  
        this.serviceOrder.status === 'InProgress' &&
        !this.serviceOrder.estimatedEndTime
      ) {
        this.$mcToast.error(this.$t('maintenance.order.text.estimatedEndTimeEmpty'))
        return
      }

      const updateFinish =
        status === 'Finished'
          ? {
              actualEndTime: actualEndTime ? new Date(actualEndTime).toISOString() : null,
              ...kilometerData,
              ...hourmeterData,
              ...refrigeratorData,
            }
          : null

      const newData = {
        ...oldData,
        ...updateFinish,
        status,
      }

      this.$apollo
        .mutate({
          mutation: isBypass ? UPDATE_SERVICE_ORDER_STATUS: UPDATE_SERVICE_ORDER,
          variables: {
            input: {
              serviceOrderId: this.serviceOrder.serviceOrderId,
              status: isBypass ? status : undefined,
              ...(isBypass ? updateFinish : undefined),
              oldData: isBypass ? undefined : oldData,
              newData: isBypass ? undefined : newData,
            },
          },
        })
        .then((res) => {
          const field = isBypass ? "updateServiceOrderStatus": "updateServiceOrder"
          if (res.data[field].isSuccessful) {
            const textPath = filteredItems.find((fi) => fi.id === status)?.label

            this.$mcToast.success({
              component: 'McToastDynamicBody',
              props: {
                contents: [
                  { tag: 'strong', text: this.serviceOrder.code, class: '__blue-highlight-text' },
                  { tag: 'span', text: this.$t('maintenance.order.text.savedAs') },
                  {
                    tag: 'strong',
                    text: textPath ? this.$t(textPath) : '',
                    class: '__status',
                  },
                ],
              },
            })
            this.$apollo.queries.serviceOrder.refetch()
            if (status === 'Finished' || status === 'InProgress') {
              this.$refs.infoFleet.$apollo.queries.serviceOrder.refetch()
            }
            this.$bvModal.hide('modal-status-finish')
          } else {
            this.$mcToast.error(res.data[field].message)
          }
        })
        .catch((err) => {
          this.$mcToast.error(err.message)
        })
    },

    handleFinish(bypass) {
      this.modal = true
      this.finishBypass = bypass

      setTimeout(() => {
        this.$bvModal.show('modal-status-finish')
      }, 500)
    },

    printPage() {
      const self = this
      this.$apollo
        .query({
          query: DOWNLOAD_SERVICE_WORK_ORDER,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              serviceOrderId: this.serviceOrder.serviceOrderId,
            },
          },
        })
        .then((res) => {
          let isSuccessful = res.data.serviceWorkOrder.isSuccessful

          if (isSuccessful) {
            var a = document.createElement('a') //Create <a>
            a.href =
              'data:application/pdf;base64,' + res.data.serviceWorkOrder.serviceWorkOrder.base64 //Image Base64 Goes here
            a.download =
              this.serviceOrder.status === 'Finished'
                ? `Halaman Cetak Biaya Servis_${this.serviceOrder.code}.pdf`
                : `Halaman Cetak Maintenance Order_${this.serviceOrder.code}.pdf` //File name Here
            a.click() //Downloaded file
          } else {
            self.$mcToast.error('Terdapat Kesalahan pada Server')
          }
        })
    },

    updateTotalData(kilometerData, hourmeterData, refrigeratorData) {
      this.kilometerData = kilometerData
      this.hourmeterData = hourmeterData
      this.refrigeratorData = refrigeratorData
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.mc-wizard) {
  margin-left: -40px;
  display: inline-block;
  width: 100%;
}
</style>
